export function getPageType(pageName) {
    if (pageName) {
        if (pageName === 'MyContent') {
            return 'Default';
        }
        else if (pageName.endsWith('Start')) {
            return 'Start';
        }
        else if (pageName.endsWith('Templates')) {
            return 'Templates';
        }
        else if (pageName.endsWith('Content')) {
            return 'Content';
        }
        else if (pageName === 'SearchPersonScoped') {
            return 'Person';
        }
        else if (pageName === 'SearchSiteScoped') {
            return 'Site';
        }
        else if (pageName === 'FormsGroupForms') {
            return 'GroupForms';
        }
        else if (pageName === 'FormsMyForms') {
            return 'MyForms';
        }
        else {
            return 'Default'; // AppGallery, Create, OfficeHome, Search
        }
    }
    else {
        return 'Other';
    }
}
export function getPageAppName(pageName) {
    var appName;
    if (pageName) {
        if (pageName === 'MyContent') {
            return pageName;
        }
        else if (pageName.endsWith('Start') ||
            pageName.endsWith('Templates') ||
            pageName.endsWith('Content')) {
            appName = pageName
                .replace('Start', '')
                .replace('Templates', '')
                .replace('Content', '');
            return appName;
        }
        else if (pageName.startsWith('Search')) {
            return 'Search';
        }
        else if (pageName.startsWith('Forms')) {
            return 'Forms';
        }
        else if (pageName === 'OfficeHome') {
            return 'Home';
        }
        else {
            return pageName; // AppGallery, Create, OfficeHome
        }
    }
    else {
        return '';
    }
}
export function convertRouteToPage(route) {
    var currentRoute = (route === null || route === void 0 ? void 0 : route.route) === 'Pwa' ? 'OfficeHome' : route === null || route === void 0 ? void 0 : route.route;
    var pageName = currentRoute !== undefined
        ? "" + ((route === null || route === void 0 ? void 0 : route.app) ? route.app : '') + currentRoute
        : undefined;
    return pageName !== undefined ? pageName : 'Unknown';
}
//# sourceMappingURL=getPageInfo.js.map